import {GridSortModel} from '@mui/x-data-grid';
import {useQuery} from '@tanstack/react-query';
import {AxiosResponse} from 'axios';
import {apiGet} from '../axiosConfig';
import {ApiResponse} from '../dto/API.dto';
import {
  IDemoStingerResponseProp,
  IDemoStingerValues,
} from '../dto/demoStingerFulfilment.dto';

export type PaginationQueryParams = {
  pageSize: number;
  page: number;
  search: string;
  sort?: GridSortModel;
};
export const apiPathGetDemoStingerById = (id: number) => {
  return `/v1/task/${id}/demo-stinger`;
};
const apiGetDemoStingerById = (id: number) => {
  return apiGet(apiPathGetDemoStingerById(id)).then(
    (response: AxiosResponse<ApiResponse<IDemoStingerResponseProp>>) => {
      return response.data.data;
    },
  );
};
export const useRqGetDemoStingerById = (id: number) => {
  return useQuery({
    queryKey: [apiPathGetDemoStingerById(id)],
    queryFn: () => apiGetDemoStingerById(id),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: Boolean(id),
  });
};

export const apiPathGetDemoStingerByType = (id: number) => {
  return `/v1/demo-stinger?request_type=${id}`;
};

const apiGetDemoStingerByType = (
  id: number,
  query: PaginationQueryParams,
): Promise<ApiResponse<IDemoStingerValues[]>> => {
  return apiGet(apiPathGetDemoStingerByType(id), {
    params: {...query, page: query.page + 1},
  }).then((response: AxiosResponse<ApiResponse<IDemoStingerValues[]>>) => {
    return response.data;
  });
};
export const useRqGetDemoStingerByType = (
  type: number,
  query: PaginationQueryParams,
) => {
  return useQuery({
    queryKey: [apiPathGetDemoStingerByType(type), type, query],
    queryFn: () => apiGetDemoStingerByType(type, query),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: Boolean(type),
  });
};

export const apiPathGetDemoStingerByReqId = (id: number) => {
  return `/v1/demo-stinger/${id}`;
};
const apiGetDemoStingerByReqId = (id: number) => {
  return apiGet(apiPathGetDemoStingerByReqId(id)).then(
    (response: AxiosResponse<ApiResponse<IDemoStingerResponseProp>>) => {
      return response.data.data;
    },
  );
};
export const useRqGetDemoStingerByReqId = (id: number) => {
  return useQuery({
    queryKey: [apiPathGetDemoStingerByReqId(id)],
    queryFn: () => apiGetDemoStingerByReqId(id),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: Boolean(id),
  });
};
export const apiPathGTPartner = () => {
  return `/v1/companies/partners`;
};

const apiGetGTPatner = () => {
  return apiGet(apiPathGTPartner()).then(
    (response: AxiosResponse<ApiResponse<IDemoStingerResponseProp>>) => {
      return response.data.data;
    },
  );
};
export const useRqGetGTPartner = () => {
  return useQuery({
    queryKey: [apiPathGTPartner()],
    queryFn: () => apiGetGTPatner(),
    refetchOnWindowFocus: false,
    retry: false,
  });
};
